import { createFileRoute } from '@tanstack/react-router'
import { Link } from '@tanstack/react-router'
import { Card, CardBody } from '@heroui/react'
import { IMAGES } from '@/lib/constants/images'

const posts = [
  {
    title: 'What Is Strokes Gained?',
    to: '/blog/what-is-strokes-gained',
    publishedAt: 'Jan 1, 2026',
    readTime: '5 min read',
    excerpt: 'A quick guide to what strokes gained means and how golfers can use it to improve.',
    image: IMAGES.scorecard,
  },
]

export const Route = createFileRoute('/blog/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <main className='mx-auto max-w-3xl px-4 py-10'>
      <h1 className='mb-6 text-3xl font-bold'>Blog</h1>
      <ul className='space-y-3'>
        {posts.map((post) => (
          <li key={post.to}>
            <Link className='block' to={post.to}>
              <Card shadow='sm' className='hover:bg-default-50'>
                <CardBody className='grid gap-4 sm:grid-cols-[180px_1fr] sm:items-center'>
                  <img
                    src={post.image}
                    alt={post.title}
                    className='h-32 w-full rounded-lg object-cover sm:h-28'
                  />
                  <div>
                    <div className='mb-1 text-xs text-default-500'>
                      {post.publishedAt} · {post.readTime}
                    </div>
                    <h2 className='text-lg font-semibold'>{post.title}</h2>
                    <p className='mt-2 text-sm text-default-600'>{post.excerpt}</p>
                  </div>
                </CardBody>
              </Card>
            </Link>
          </li>
        ))}
      </ul>
    </main>
  )
}
